import { FC } from "react"
import { useTranslation } from 'react-i18next'
import { useLocation, useSearchParams } from 'react-router'
import { A11y, Autoplay, Scrollbar } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"

import '../../../node_modules/swiper/swiper-bundle.min.css'
import '../../../node_modules/swiper/modules/scrollbar.min.css'
import '../../../node_modules/swiper/modules/autoplay.min.css'
import { SearchParamKey } from '@app/store/appStore.types'
import useAppPersistentStore from '@app/store/useAppPersistentStorage'
import useAppSessionStore from '@app/store/useAppSessionStore'
import { useAppModeStore } from '@shared/config/appMode.store'
import { useComponentVisibilityStore } from "@shared/store/useComponentVisibilityStore"
import Slide from "@widgets/slider/slide/Slide"

import { getSlides } from "./constants.tsx"
import styles from "./slider.module.css"


const Slider: FC = () => {
    const { ready } = useTranslation()
    const { pathname } = useLocation()
    const [searchParams] = useSearchParams()
    const { setIsSliderVisibleOnMobile } = useComponentVisibilityStore()
    const isUkUser = useAppModeStore((state) => state.isWithoutCrypto)
    const signupOriginDomain = useAppPersistentStore((state) => state.searchParams.signup_origin_domain)
    const loginOriginDomain = useAppSessionStore((state) => state.searchParams.login_origin_domain)
    const originDomain = pathname.startsWith('/sign-up')
        ? searchParams.get(SearchParamKey.SIGNUP_ORIGIN_DOMAIN) ?? signupOriginDomain
        : searchParams.get(SearchParamKey.LOGIN_ORIGIN_DOMAIN) ?? loginOriginDomain
    const slides = getSlides(originDomain, isUkUser)

    const handleClick = () => {
        setIsSliderVisibleOnMobile(false)
    }

    if (!ready) return null

    return (
        <div className={styles.swiperContainer}>
            <div className={styles.swiper}>
                <Swiper
                    key={`${originDomain ?? 'unknown'}-${isUkUser}`}
                    style={{ width: '100%' }}
                    modules={[Scrollbar, A11y, Autoplay]}
                    slidesPerView={1}
                    scrollbar={{
                        draggable: true,
                        horizontalClass: styles.scrollbar,
                        dragClass: styles.draggableEL,
                    }}
                    autoplay={{
                        delay: 4000,
                    }}
                    loop={true}
                    wrapperClass={styles.wrapper}
                >
                    {slides.map((slide, idx) => (
                        <SwiperSlide key={idx}>
                            <Slide
                                {...slide}
                                onButtonClick={handleClick}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    )
}

export default Slider
